// extracted by mini-css-extract-plugin
export default {"anchor":"AsideNav_anchor__tzU3n"};